import { cn } from '@/lib/utils';
import { OctagonAlertIcon } from 'lucide-react';
export function ImageHoverAltText({ isResizing, isHovering, alt }: { isResizing: boolean; isHovering: boolean; alt: string }) {
    const missingAlt = !alt?.trim();
    return (
        !isResizing && (
            <div
                className={cn(
                    'pointer-events-none absolute inset-x-0 bottom-0 z-10 flex items-center gap-1.5 px-2 py-1.5',
                    missingAlt
                        ? 'bg-gradient-to-t from-red-900/95 via-red-800/70 to-transparent'
                        : 'bg-gradient-to-t from-black/80 via-black/50 to-transparent',
                    isHovering ? 'opacity-100' : 'opacity-0',
                )}
            >
                {missingAlt && (
                    <OctagonAlertIcon
                        className="size-4 shrink-0 text-red-200"
                        aria-hidden
                    />
                )}
                <span
                    className={cn('min-w-0 flex-1 truncate text-sm font-medium', missingAlt ? 'font-semibold text-red-100' : 'text-white')}
                >
                    {missingAlt ? 'Missing alt text' : alt}
                </span>
            </div>
        )
    );
}
